/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesPaymenConfiguration = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesPaymenConfiguration = typeof WebApiModelsEnumerationTypesPaymenConfiguration[keyof typeof WebApiModelsEnumerationTypesPaymenConfiguration];


export function WebApiModelsEnumerationTypesPaymenConfigurationFromJSON(json: any): WebApiModelsEnumerationTypesPaymenConfiguration {
    return WebApiModelsEnumerationTypesPaymenConfigurationFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesPaymenConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesPaymenConfiguration {
    return json as WebApiModelsEnumerationTypesPaymenConfiguration;
}

export function WebApiModelsEnumerationTypesPaymenConfigurationToJSON(value?: WebApiModelsEnumerationTypesPaymenConfiguration | null): any {
    return value as any;
}

